import { render, staticRenderFns } from "./myFollow.vue?vue&type=template&id=035d6319&scoped=true&"
import script from "./myFollow.vue?vue&type=script&lang=js&"
export * from "./myFollow.vue?vue&type=script&lang=js&"
import style0 from "./myFollow.vue?vue&type=style&index=0&id=035d6319&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d6319",
  null
  
)

export default component.exports